import React from 'react';
import {
  Button,
  createStyles,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  makeStyles,
} from '@material-ui/core';

// CSSスタイルを定義
const useStyles = makeStyles((theme) =>
  createStyles({
    content: {
      textAlign: 'center',
    },
    text: {
      marginTop: theme.spacing(4),
      fontSize: 20,
      whiteSpace: 'pre-line', // \nで改行用
    },
    closeButton: {
      fontSize: 18,
    },
  }),
);

const AlertDialog = React.memo(function AlertDialog(props) {
  const { open, onClose, children } = props;
  const classes = useStyles();

  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
      <DialogContent className={classes.content}>
        <DialogContentText className={classes.text}>{children}</DialogContentText>
      </DialogContent>

      <DialogActions>
        <Button onClick={onClose} color="primary" className={classes.closeButton}>
          閉じる
        </Button>
      </DialogActions>
    </Dialog>
  );
});

AlertDialog.displayName = 'AlertDialog';

export default AlertDialog;
